module.exports = __webpack_public_path__ + "static/media/card-VIS.3b763630.svg";